import { useDispatch } from 'react-redux'

import { TableList, TableColumns } from 'components/common'

import CardTypeApi, { getDetailUrl, pkField } from 'models/CardType/api'
import { CardTypeActions } from 'models/CardType/slice'
import CardTypeValue from '../CardTypeValue'


const defaultColumnList = ['name', 'sort', 'isActive', 'actions'];


const CardTypeList = ({ columnList, params, filterParams, onEdit }) => {
  const [apiGetList, apiGetListProps] = CardTypeApi.endpoints.getCardTypeList.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = CardTypeApi.endpoints.updateCardType.useMutation();
  const [apiDelete, apiDeleteProps] = CardTypeApi.endpoints.deleteCardType.useMutation();
  const [apiBatchDelete, apiBatchDeleteProps] = CardTypeApi.endpoints.batchDeleteCardType.useMutation();

  const dispatch = useDispatch();

  const fields = {
    name: {
      title: 'Название',
      sorter: true,
      render: (val, item) => (<CardTypeValue detail={item} asLink={true} isBack={true} />),
    },
    sort: { title: 'Сортировка', sorter: true, width: 130 },
    isActive: TableColumns.getColumnOnOff({ title: 'Активно', fieldName: 'isActive', apiUpdate, apiUpdateProps }),

    actions: TableColumns.getColumnActions({
      getDetailUrl,
      getActions: (item) => [
        { name: 'edit', action: () => dispatch(CardTypeActions.openForm({ name: 'editForm', pk: item[pkField] })) },
        { name: 'delete', action: () => apiDelete(item[pkField]) },
      ]
    }),
  };

  return (
    <TableList
      queryKey="cardType"
      rowKey={pkField}
      params={params}
      filterParams={filterParams}
      fields={fields}
      columnList={columnList || defaultColumnList}

      apiGetList={apiGetList}
      apiGetListProps={apiGetListProps}
      apiUpdateProps={apiUpdateProps}
      apiDeleteProps={apiDeleteProps}
      apiBatchDelete={apiBatchDelete}
      apiBatchDeleteProps={apiBatchDeleteProps}
      onEdit={onEdit}

      rowSelection={false}
      hidePagination={false}
      hideStat={false}
    />
  );
}

export default CardTypeList;
